import { api } from './client';

export interface DocumentType {
  id: string;
  companyId: string;
  code: string;
  name: string;
  requiresCustomTitle: boolean;
  isActive: boolean;
  sortOrder: number;
  sitesCount?: number;
  createdAt: string;
  updatedAt: string;
}

export interface DocumentTypeForSite {
  id: string;
  code: string;
  name: string;
  requiresCustomTitle: boolean;
}

export interface DocumentTypeSiteAssignment {
  id: string;
  code: string;
  name: string;
  isAssigned: boolean;
}

export interface CreateDocumentTypeRequest {
  code: string;
  name: string;
  requiresCustomTitle?: boolean;
  isActive?: boolean;
  sortOrder?: number;
}

export interface UpdateDocumentTypeRequest {
  code?: string;
  name?: string;
  requiresCustomTitle?: boolean;
  isActive?: boolean;
  sortOrder?: number;
}

export const documentTypesApi = {
  getAll: (includeInactive = false): Promise<DocumentType[]> =>
    api.get(`/document-types${includeInactive ? '?includeInactive=true' : ''}`),

  getForSite: (): Promise<DocumentTypeForSite[]> =>
    api.get('/document-types/for-site'),

  getSiteAssignments: (id: string): Promise<DocumentTypeSiteAssignment[]> =>
    api.get(`/document-types/${id}/sites`),

  updateSiteAssignments: (id: string, siteIds: string[]): Promise<DocumentTypeSiteAssignment[]> =>
    api.put(`/document-types/${id}/sites`, { siteIds }),

  getAssignedTypeIds: (siteId: string): Promise<string[]> =>
    api.get(`/document-types/site-types/${siteId}`),

  bulkAssignToSite: (siteId: string, documentTypeIds: string[]): Promise<void> =>
    api.put(`/document-types/site-types/${siteId}`, { siteIds: documentTypeIds }),

  create: (data: CreateDocumentTypeRequest): Promise<DocumentType> =>
    api.post('/document-types', data),

  update: (id: string, data: UpdateDocumentTypeRequest): Promise<DocumentType> =>
    api.patch(`/document-types/${id}`, data),

  deactivate: (id: string): Promise<DocumentType> =>
    api.delete(`/document-types/${id}`),

  reactivate: (id: string): Promise<DocumentType> =>
    api.patch(`/document-types/${id}/reactivate`, {}),
};
